import React from 'react';
import { textRight, linkText } from 'scy/utils.mod.scss';
import { top_xs, right_sm, tablet_right_0 } from 'scy/padding.mod.scss';

export default function LoginFooter() {
  return (
    <div className={`${textRight} ${top_xs} ${right_sm} ${tablet_right_0}`}>
      <small>
        Already have an account?{' '}
        <a href="/login" className={linkText}>
          Log in
        </a>
        .
      </small>
    </div>
  );
}
